import { createContext } from "react";
import OrderArticle from "../models/order/OrderArticle.ts";

export const AddOrderArticleContext = createContext<
  (orderArticle: OrderArticle, allowUpsell?: boolean) => Promise<void>
>(() => new Promise<void>((resolve) => resolve()));
